import { render } from "./ActionsGroup.vue?vue&type=template&id=c27769ac"
import script from "./ActionsGroup.vue?vue&type=script&lang=js"
export * from "./ActionsGroup.vue?vue&type=script&lang=js"
script.render = render

export default script